var React = require('react');

function AreaLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M64.4 91.9l-9.5-26.7h-34l-9.5 26.7L0 80.5 30.6.1h15l30.9 79.5-12.1 12.3zM37.8 17.3L25.4 52.1h24.9L37.8 17.3zM287.8 91.9l-9.5-26.7h-34l-9.5 26.7-11.3-11.3L254.2.2h15L300 79.6l-12.2 12.3zm-26.5-74.6l-12.5 34.8h24.9l-12.4-34.8zM125.5 50.1v.2c2.3 1.5 5.1 4.8 10.4 12.4l13.4 19-10.8 10.1-17.9-26C111.7 53 110 52 104.7 52h-1.3v40h-15V0h28c20.5 0 32.3 9.1 32.3 25.4 0 15.1-10.6 22.8-23.2 24.3m-10-37.6h-11v28h11.9c11.8 0 17.2-5.1 17.2-14.1s-5.6-13.9-18-13.9M177.5 37.1h31v.1L196 49.1h-18.5v30h36v13h-51V.1h50v13h-35z"}));
}

AreaLogo.defaultProps = {"x":"0","y":"0","version":"1.1","viewBox":"0 0 300 91.6","xmlSpace":"preserve"};

module.exports = AreaLogo;

AreaLogo.default = AreaLogo;
